import { render } from "./FilterPriceRange.vue?vue&type=template&id=52c7b1c0&scoped=true&ts=true"
import script from "./FilterPriceRange.vue?vue&type=script&lang=ts"
export * from "./FilterPriceRange.vue?vue&type=script&lang=ts"

import "./FilterPriceRange.vue?vue&type=style&index=0&id=52c7b1c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c7b1c0"]])

export default __exports__